import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from "../../services/analytics.service";
import './form-item-deceased-estates-cmb.component.scss';
var FormItemDeceasedEstatesCmb = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemDeceasedEstatesCmb, _super);
    function FormItemDeceasedEstatesCmb(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemDeceasedEstatesCmb.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now__button"));
        this.recipientInput = this.element.querySelector("input[name=recipient]");
        this.emailInput = this.element.querySelector("input[name=email]");
        this.subjectInput = this.element.querySelector("input[name=subject]");
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
    };
    FormItemDeceasedEstatesCmb.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                // loader + hide form
                var loader = _form.querySelector(".form__loader--container");
                var fieldsContainer = _form.querySelector(".form__fields--container");
                loader.classList.add("active");
                fieldsContainer.classList.add("hidden");
                // Check if gRecaptcha is enabled for this form
                if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                    var gToken_1 = '';
                    try {
                        // Attempt to get recaptcha token
                        grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var err_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                    case 1:
                                        gToken_1 = _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        // Log error
                                        console.log("Unable to retrieve gRecaptcha Token");
                                        console.log(err_1);
                                        return [3 /*break*/, 3];
                                    case 3:
                                        // Set recaptcha token
                                        this.gRecaptchaToken = gToken_1;
                                        this.submitForm(_form);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    catch (err) {
                        // Log error
                        console.log("Unable to retrieve gRecaptcha Token");
                        console.log(err);
                        _this.submitForm(_form);
                    }
                }
                else {
                    _this.submitForm(_form);
                }
            }
        }); });
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute('hidden', 'true');
                _this.showMoreBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute('hidden', 'true');
                _this.showLessBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
                _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingGroupShowBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute('hidden');
                _this.dataSharingGroupHideBtn.removeAttribute('hidden');
                _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
                _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute('hidden');
                _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemDeceasedEstatesCmb.prototype.resetForm = function () {
        if (this.form) {
            this.form.reset();
            var formContainerLoader = this.element.querySelector(".form__loader--container");
            var formContainerThankyou = this.element.querySelector(".form__thankyou--container");
            var error = this.element.querySelector(".form__error--container");
            formContainerLoader.classList.remove("active");
            formContainerThankyou.classList.remove("active");
            error.classList.remove("active");
        }
    };
    FormItemDeceasedEstatesCmb.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemDeceasedEstatesCmb.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        var sha_email = "";
        // variables
        var _description = form.querySelector("input[name=description]");
        var _email = form.querySelector("input[name=email]");
        var _recipient = form.querySelector("input[name=recipient]");
        var _subject = form.querySelector("input[name=subject]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _queryType = form.querySelector('select[name=query-type]');
        var _comments = form.querySelector("textarea[name=comments-query]");
        var _date = form.querySelector("input[name=date]");
        var _time = form.querySelector("select[name=time]");
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        var _dateTime = "anytime";
        if (_date && _time) {
            if (_time.value !== "Anytime") {
                _dateTime = _date.value + " " + _time.value;
            }
        }
        var _postData = {
            'description': (_description ? _description.value : ""),
            'email': (_email ? _email.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'firstname': (_firstname ? _firstname.value : ""),
            'surname': (_surname ? _surname.value : ""),
            'contact': (_contactNumber ? _contactNumber.value : ""),
            '_queryType': (_queryType ? _queryType.value : ''),
            '_comments': (_comments ? _comments.value : ""),
            'dataPrivacyConsent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharingWithThirdPartiesMarketingConsent': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingAcrossBordersWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-boarders'),
            'timeToCall': _dateTime,
            'recaptchaToken': this.gRecaptchaToken
        };
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var analyticsService = new AnalyticsService();
        // service
        var url = this.baseUrl + "/services/deceasedEstatesForm.jsp";
        this.formsService
            .postForm(url, this.http.serialiseObject(_postData))
            .then(function (pResponse) {
            loader.classList.remove("active");
            if (!pResponse.data || pResponse.data.toString().includes("invalid") || pResponse.data.toString().includes("error")) {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid response");
                thankYou.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                error.classList.remove("hidden");
                error.classList.add("active");
            }
            else if (pResponse.data.captchaResponse != null && pResponse.data.captchaResponse == false) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                thankYou.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                error.classList.remove("hidden");
                error.classList.add("active");
            }
            else {
                if (pResponse.code) {
                    analyticsService.dtmFormComplete("complete", pResponse.code, false, "", "", _postData.contact);
                }
                else if (pResponse.status) {
                    analyticsService.dtmFormComplete("complete", pResponse.status, false, "", "", _postData.contact);
                }
                else {
                    analyticsService.dtmFormComplete("complete", "200", false, "", "", _postData.contact);
                }
                thankYou.classList.add("active");
                error.classList.remove("active");
                error.classList.add("hidden");
                success.classList.remove("hidden");
                success.classList.add("active");
            }
        })
            .catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occurred|" + url);
            loader.classList.remove("active");
            thankYou.classList.add("active");
            success.classList.remove("active");
            success.classList.add("hidden");
            error.classList.remove("hidden");
            error.classList.add("active");
        });
        this.resetForm();
    };
    return FormItemDeceasedEstatesCmb;
}(Base));
export { FormItemDeceasedEstatesCmb };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-deceased-estates-cmb/form-item-deceased-estates-cmb.component.ts
// module id = 889
// module chunks = 0